<template>
  <v-dialog :value="dialogShow" max-width="360" content-class="ios-add-home-dialog" @click:outside="closeAction">
    <v-card class="ios-add-home-card">
      <div class="ios-add-home-header">
        <img src="/img/icons/favicon-512x512.png" width="44" height="44" alt="NG88" />
        <div class="ios-add-home-heading">
          <div class="ios-add-home-title">{{ $t('label.iosAddToHomeTitle') }}</div>
          <div class="ios-add-home-body">{{ $t('label.iosAddToHomeBody') }}</div>
        </div>
        <v-icon class="ios-add-home-close" color="white" @click="closeAction">mdi-close</v-icon>
      </div>

      <div class="ios-add-home-content">
        <div v-if="inAppBrowser" class="ios-add-home-warning">{{ $t('label.iosAddToHomeInApp') }}</div>

        <ol class="ios-add-home-steps">
          <li>
            <span class="ios-step-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" width="22" height="22">
                <path fill="currentColor" d="M12 3l4 4h-3v7h-2V7H8l4-4zm-7 11h2v5h10v-5h2v7H5v-7z" />
              </svg>
            </span>
            <span>{{ $t('label.iosAddToHomeStep1') }}</span>
          </li>
          <li>
            <span class="ios-step-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" width="22" height="22">
                <path fill="currentColor" d="M4 4h7v2H6v12h12v-5h2v7H4V4zm9 0h7v7h-2V7.4l-6.3 6.3-1.4-1.4L16.6 6H13V4z" />
              </svg>
            </span>
            <span>{{ $t('label.iosAddToHomeStep2') }}</span>
          </li>
          <li>
            <span class="ios-step-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" width="22" height="22">
                <path fill="currentColor" d="M9 16.2l-3.5-3.5L4 14.2 9 19l11-11-1.5-1.5L9 16.2z" />
              </svg>
            </span>
            <span>{{ $t('label.iosAddToHomeStep3') }}</span>
          </li>
        </ol>

        <button type="button" class="ios-add-home-done" @click="closeAction">{{ $t('label.iosAddToHomeDone') }}</button>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'IosAddToHomeDialog',
  props: {
    dialogShow: {
      type: Boolean,
      required: true,
      default: false
    },
    inAppBrowser: {
      type: Boolean,
      required: false,
      default: false
    },
    closeAction: {
      type: Function,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.ios-add-home-card {
  border-radius: 16px !important;
  overflow: hidden;
}

.ios-add-home-header {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px;
  background: transparent linear-gradient(180deg, #0047ff 0%, #5a00b4 100%) 0% 0% no-repeat padding-box;
  color: #fff;

  img {
    border-radius: 10px;
    flex: 0 0 auto;
  }
}

.ios-add-home-heading {
  flex: 1;
}

.ios-add-home-title {
  font-size: 16px;
  font-weight: 700;
  line-height: 1.3;
}

.ios-add-home-body {
  margin-top: 4px;
  font-size: 13px;
  line-height: 1.4;
  opacity: 0.92;
}

.ios-add-home-close {
  flex: 0 0 auto;
}

.ios-add-home-content {
  padding: 16px;
  background: #fff;
}

.ios-add-home-warning {
  margin-bottom: 12px;
  padding: 10px 12px;
  border-radius: 8px;
  background: #fff4e5;
  color: #8a4b00;
  font-size: 13px;
  line-height: 1.4;
}

.ios-add-home-steps {
  margin: 0;
  padding: 0;
  list-style: none;

  li {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 10px;
    color: #1d1d1f;
    font-size: 14px;
    line-height: 1.35;
  }
}

.ios-step-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: #f3e9ff;
  color: #5a00b4;
  flex: 0 0 auto;
}

.ios-add-home-done {
  width: 100%;
  margin-top: 6px;
  border: 0;
  border-radius: 10px;
  padding: 12px 16px;
  background: linear-gradient(to bottom, #ffab2d, #ff7700);
  color: #fff;
  font-size: 15px;
  font-weight: 700;
}
</style>
